import firebase from 'firebase/app';
import 'firebase/auth';

const getUser = () => firebase.auth().currentUser;
const updateUser = ({ displayName }) => {
  const user = getUser();
  return user.updateProfile({ displayName });
};
const deleteUser = () => {
  const user = getUser();
  return user.delete();
};
const sendLoginLink = (email) => {
  const url = `${window.location.origin}/auth?email=${email}`;
  return firebase.auth().sendSignInLinkToEmail(email, {
    url,
    handleCodeInApp: true,
  });
};
const signIn = email => (
  firebase.auth().signInWithEmailLink(email, window.location.href)
);
const signOut = () => firebase.auth().signOut();

export {
  sendLoginLink,
  signIn,
  getUser,
  updateUser,
  deleteUser,
  signOut,
};
